import React, { ReactElement, SyntheticEvent } from 'react';
import { styled } from '@linaria/react';
import { NoStyleLink } from '../helpers/NoStyleLink';
type DropDownMenuLinkProps = {
  children: React.ReactNode;
  /** Pass through classname to allow styles overrides */
  className?: string;
  url?: string;
  icon?: ReactElement;
  onClick?: (e: SyntheticEvent) => void;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
};
const _exp = /*#__PURE__*/() => NoStyleLink;
const LinkElement = /*#__PURE__*/styled(_exp())({
  name: "LinkElement",
  class: "lscw38r",
  propsAsIs: true
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i11gmxyo",
  propsAsIs: false
});
export const DropDownMenuLink = ({
  children,
  url = '#',
  icon,
  className,
  onClick,
  dataId
}: DropDownMenuLinkProps) => {
  return <LinkElement data-Id={dataId} href={url} onClick={onClick} className={className}>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      {children}
    </LinkElement>;
};

require("./DropDownMenuLink.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./DropDownMenuLink.tsx");